var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "main-content" }, [
    _c("div", { staticClass: "card" }, [
      _vm._m(0),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "card-body" },
        [
          _c("div", { staticClass: "form-group" }, [
            _c("label", { attrs: { for: "" } }, [_vm._v("Поиск препарата")]),
            _vm._v(" "),
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.searchDrugText,
                  expression: "searchDrugText",
                },
              ],
              staticClass: "form-control",
              attrs: {
                placeholder: "Введите название для поиска",
                type: "text",
              },
              domProps: { value: _vm.searchDrugText },
              on: {
                keyup: _vm.filterDrugs,
                input: function ($event) {
                  if ($event.target.composing) return
                  _vm.searchDrugText = $event.target.value
                },
              },
            }),
          ]),
          _vm._v(" "),
          _c("pulse-loader", {
            staticClass: "text-center",
            attrs: {
              loading: _vm.loading,
              color: _vm.$constants.LOADING_COLOR,
            },
          }),
          _vm._v(" "),
          !_vm.loading
            ? _c("table", { staticClass: "table table-sm table-hover mt-1" }, [
                _vm._m(1),
                _vm._v(" "),
                _c(
                  "tbody",
                  _vm._l(_vm.filteredRecords, function (r, i) {
                    return _c("tr", [
                      _c("td", [_vm._v(_vm._s(i + 1))]),
                      _vm._v(" "),
                      _c(
                        "td",
                        [
                          _vm.drugsImages[r.drug.id]
                            ? _c(
                                "v-popover",
                                {
                                  staticClass: "d-inline",
                                  attrs: {
                                    placement: "bottom",
                                    "auto-hide": true,
                                  },
                                },
                                [
                                  _c("i", {
                                    staticClass:
                                      "icon-fa icon-fa-photo pointer",
                                  }),
                                  _vm._v(" "),
                                  _c("template", { slot: "popover" }, [
                                    _c("img", {
                                      attrs: {
                                        src: _vm.drugsImages[r.drug.id],
                                        alt: "",
                                      },
                                    }),
                                  ]),
                                ],
                                2
                              )
                            : _vm._e(),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c("td", [
                        _c("p", [_vm._v(_vm._s(r.drug.title))]),
                        _vm._v(" "),
                        _c("p", [_vm._v(_vm._s(r.drug.en_title))]),
                        _vm._v(" "),
                        r.drug.pack_comment
                          ? _c("p", { staticClass: "text-muted" }, [
                              _vm._v(_vm._s(r.drug.pack_comment)),
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        r.drug.pack_box_comment
                          ? _c("p", { staticClass: "text-muted" }, [
                              _vm._v(_vm._s(r.drug.pack_box_comment)),
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        r.drug.cool
                          ? _c("p", [
                              _c("i", {
                                staticClass:
                                  "icon icon-snowflake pull-left mr-2",
                              }),
                              _vm._v(" Требуется хладоген"),
                            ])
                          : _vm._e(),
                      ]),
                      _vm._v(" "),
                      _c("td", [
                        r.drug.pack_set != 1
                          ? _c("span", { staticClass: "badge badge-info" }, [
                              _vm._v(
                                "1 комплект (" +
                                  _vm._s(+r.drug.pack_set) +
                                  " зав.уп.)"
                              ),
                            ])
                          : _vm._e(),
                      ]),
                      _vm._v(" "),
                      _c("td", [
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: r.qty,
                              expression: "r.qty",
                            },
                          ],
                          staticClass: "form-control",
                          attrs: { type: "text", disabled: "" },
                          domProps: { value: r.qty },
                          on: {
                            input: function ($event) {
                              if ($event.target.composing) return
                              _vm.$set(r, "qty", $event.target.value)
                            },
                          },
                        }),
                      ]),
                      _vm._v(" "),
                      _c("td", [
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.revisionRecords[r.drug_id].revisionQty,
                              expression:
                                "revisionRecords[r.drug_id].revisionQty",
                            },
                          ],
                          staticClass: "form-control",
                          attrs: { type: "number" },
                          domProps: {
                            value: _vm.revisionRecords[r.drug_id].revisionQty,
                          },
                          on: {
                            change: function ($event) {
                              return _vm.updateRecord(r.drug_id, "qty")
                            },
                            input: function ($event) {
                              if ($event.target.composing) return
                              _vm.$set(
                                _vm.revisionRecords[r.drug_id],
                                "revisionQty",
                                $event.target.value
                              )
                            },
                          },
                        }),
                      ]),
                      _vm._v(" "),
                      _c(
                        "td",
                        [
                          _vm._l(
                            _vm.revisionRecords[r.drug_id].expireDates,
                            function (ex, i) {
                              return [
                                i === 0
                                  ? [
                                      _c(
                                        "div",
                                        { staticClass: "input-group" },
                                        [
                                          _c("input", {
                                            directives: [
                                              {
                                                name: "mask",
                                                rawName: "v-mask",
                                                value: _vm.expireMask,
                                                expression: "expireMask",
                                              },
                                              {
                                                name: "model",
                                                rawName: "v-model",
                                                value: ex.date,
                                                expression: "ex.date",
                                              },
                                            ],
                                            staticClass: "form-control",
                                            attrs: {
                                              type: "text",
                                              placeholder: "12.2025",
                                            },
                                            domProps: { value: ex.date },
                                            on: {
                                              change: function ($event) {
                                                return _vm.updateRecord(
                                                  r.drug_id,
                                                  "expireDate"
                                                )
                                              },
                                              input: function ($event) {
                                                if ($event.target.composing)
                                                  return
                                                _vm.$set(
                                                  ex,
                                                  "date",
                                                  $event.target.value
                                                )
                                              },
                                            },
                                          }),
                                          _vm._v(" "),
                                          _c(
                                            "div",
                                            {
                                              staticClass: "input-group-append",
                                            },
                                            [
                                              _c(
                                                "button",
                                                {
                                                  staticClass:
                                                    "btn btn-outline-success btn-xs",
                                                  on: {
                                                    click: function ($event) {
                                                      return _vm.addNewDate(
                                                        r.drug_id
                                                      )
                                                    },
                                                  },
                                                },
                                                [
                                                  _c("i", {
                                                    staticClass:
                                                      "icon-fa icon-fa-plus",
                                                  }),
                                                ]
                                              ),
                                            ]
                                          ),
                                        ]
                                      ),
                                    ]
                                  : [
                                      _c("input", {
                                        directives: [
                                          {
                                            name: "mask",
                                            rawName: "v-mask",
                                            value: _vm.expireMask,
                                            expression: "expireMask",
                                          },
                                          {
                                            name: "model",
                                            rawName: "v-model",
                                            value: ex.date,
                                            expression: "ex.date",
                                          },
                                        ],
                                        staticClass: "form-control",
                                        attrs: {
                                          placeholder: "12.2025",
                                          type: "text",
                                        },
                                        domProps: { value: ex.date },
                                        on: {
                                          change: function ($event) {
                                            return _vm.updateRecord(
                                              r.drug_id,
                                              "expireDate"
                                            )
                                          },
                                          input: function ($event) {
                                            if ($event.target.composing) return
                                            _vm.$set(
                                              ex,
                                              "date",
                                              $event.target.value
                                            )
                                          },
                                        },
                                      }),
                                    ],
                              ]
                            }
                          ),
                        ],
                        2
                      ),
                    ])
                  }),
                  0
                ),
              ])
            : _vm._e(),
        ],
        1
      ),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "card-header" }, [
      _c("h5", [_vm._v("Ревизия склада")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("thead", [
      _c("tr", [
        _c("th"),
        _vm._v(" "),
        _c("th"),
        _vm._v(" "),
        _c("th", [_vm._v("Препарат")]),
        _vm._v(" "),
        _c("th", [_vm._v("Комплектность")]),
        _vm._v(" "),
        _c("th", [_vm._v("На складе")]),
        _vm._v(" "),
        _c("th", [_vm._v("Ревизия")]),
        _vm._v(" "),
        _c("th", [_vm._v("Срок годности")]),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }